import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const About = () => {
  return (
    <div>
      <h2 className="mb-4">About Odyssey23</h2>
      
      <Row>
        <Col md={8}>
          <Card className="mb-4">
            <Card.Body>
              <h4>What is Odyssey23?</h4>
              <p>
                Odyssey23 is an ML-powered data cleaning platform that automates the tedious process 
                of validating, cleaning, and detecting anomalies in your datasets. Built with modern 
                machine learning techniques, it helps data scientists and analysts spend less time 
                cleaning data and more time on analysis.
              </p>
              
              <h4 className="mt-4">Key Features</h4>
              <ul>
                <li><strong>Automated Validation</strong> - Detects missing values, duplicates, empty columns, and type mismatches</li>
                <li><strong>ML Anomaly Detection</strong> - Uses ensemble of Isolation Forest and Local Outlier Factor algorithms</li>
                <li><strong>Interactive Review</strong> - View original and cleaned data side-by-side with anomalies highlighted</li>
                <li><strong>Feedback Loop</strong> - Mark anomalies as true/false positives to improve the model</li>
                <li><strong>Smart Fixes</strong> - Get suggested replacement values or delete problematic rows</li>
                <li><strong>Batch Processing</strong> - Upload and process multiple files at once</li>
              </ul>

              <h4 className="mt-4">Technology Stack</h4>
              <Row>
                <Col md={6}>
                  <p><strong>Frontend:</strong></p>
                  <ul>
                    <li>React 16</li>
                    <li>Bootstrap 4</li>
                    <li>Recharts</li>
                  </ul>
                </Col>
                <Col md={6}>
                  <p><strong>Backend:</strong></p>
                  <ul>
                    <li>Python 3.11</li>
                    <li>Flask 2.3</li>
                    <li>scikit-learn 1.2</li>
                    <li>SQLite + SQLAlchemy</li>
                  </ul>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="mb-4">
            <Card.Header>
              <h5 className="mb-0">Contact</h5>
            </Card.Header>
            <Card.Body>
              <p>Have questions, feedback, or suggestions?</p>
              <p>
                <strong>Email:</strong><br />
                <a href="mailto:info@odyssey23.com">info@odyssey23.com</a>
              </p>
            </Card.Body>
          </Card>

          <Card className="mb-4">
            <Card.Header>
              <h5 className="mb-0">Author</h5>
            </Card.Header>
            <Card.Body>
              <p><strong>Julia Kvetnaya</strong></p>
              <p>
                Senior Software Engineer with 12+ years of experience in distributed systems 
                and backend engineering. MS Computer Science from UIUC.
              </p>
              <p>
                <a href="https://www.linkedin.com/in/kv-julia/" target="_blank" rel="noopener noreferrer">
                  LinkedIn Profile
                </a>
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default About;